if (!customElements.get('image-banner')) {
  customElements.define(
    'image-banner',
    class ImageBanner extends HTMLElement {
      constructor() {
        super();
        this.idSection = this.getAttribute('data-section-id');
        this.enableScroll = this.getAttribute('data-enable-auto-scroll');
        this.hasBanner = this.getAttribute('data-hasBanner');
        if (this.hasBanner === 'true') {
          this.initSlider(this);
        }
      }

      initSlider(self) {
        let sectionId = self.idSection;
        if (self.enableScroll === 'true') {
          new Swiper(`.swiper-hero-banner-${sectionId}`, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
              delay: 5000,
            },
            pagination: {
              el: `.swiper-pagination-${sectionId}`,
              clickable: true,
            },
            navigation: {
              nextEl: `.swiper-button-next-${sectionId}`,
              prevEl: `.swiper-button-prev-${sectionId}`,
            },
            mousewheel: {
              forceToAxis: true,
            },
          });
        } else {
          new Swiper(`.swiper-hero-banner-${sectionId}`, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            pagination: {
              el: `.swiper-pagination-${sectionId}`,
              clickable: true,
            },
            navigation: {
              nextEl: `.swiper-button-next-${sectionId}`,
              prevEl: `.swiper-button-prev-${sectionId}`,
            },
            mousewheel: {
              forceToAxis: true,
            },
          });
        }
      }
    }
  );
}
